import { UnitEnum } from '@/api/rest/resources/types/units';

export const formatUnit = (unit?: UnitEnum) => {
  switch (unit) {
    case UnitEnum['m^3']:
      return 'm³';
    case UnitEnum['m^3/ha']:
      return 'm³/ha';
    case UnitEnum['m^2']:
      return 'm²';
    case UnitEnum['km^2']:
      return 'km²';
    case UnitEnum['m^3/m^3/a']:
      return '';
    case UnitEnum['t_CO2/ha']:
      return 't CO₂/ha';
    case UnitEnum.t_CO2:
      return 't CO₂';
    case UnitEnum[UnitEnum.none]:
      return '';
    case UnitEnum[UnitEnum.years]:
      // TODO: MVP-7533 - Support multiple language translations
      return 'Years';
    case UnitEnum['people/km^2']:
      // TODO: MVP-7533 - Support multiple language translations
      return 'people/km²';
    case UnitEnum['kg/100m^2']:
      return 'kg/100m²';
    case UnitEnum.shannon:
      return "H'";
    case UnitEnum['shoots/m^2']:
      return 'shoots/m²';
    default:
      return unit;
  }
};
